import { useContext, useState } from "react";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../../../components";
import "./index.scss";
import Context from "../../../../../../context";
import { IItem } from "../../../../../../types/common.interface";
import "./index.scss";
import { useTranslation } from "react-i18next";

const Create = () => {
  const { setShowModal, showModal, createFunction } = useContext(
    Context.FinancialGroupScreen
  );
  const [errors, setErrors] = useState({
    type: "",
    name: "",
    total: "",
    cycle: "",
    agentSubscription: "",
  });

  const [financialGroupData, setFinancialGroupData] = useState<any>({
    name: "",
    agentSubscription: undefined,
    type: "",
    share: {
      admin: "",
      municipality: "",
      company: "",
      superAgent: "",
      driver: "",
      tax: "",
    },
    cycle: 0,
  });

  const { t } = useTranslation();

  const onCreate = () => {
    let data = {};
    let errorsText = {
      type: "",
      name: "",
      total: "",
      cycle: "",
      agentSubscription: "",
    };
    let total = 0;

    // if (selectedType?.value === "student") {
    total =
      Number(financialGroupData.share.admin) +
      Number(financialGroupData.share.superAgent) +
      Number(financialGroupData.share.municipality) +
      Number(financialGroupData.share.company) +
      Number(financialGroupData.share.driver) +
      Number(financialGroupData.share.tax);
    data = {
      name: financialGroupData.name,
      agentSubscription: financialGroupData?.agentSubscription
        ? financialGroupData?.agentSubscription
        : undefined,
      subscriptionStudent: {
        share: {
          admin: financialGroupData.share.admin,
          company: financialGroupData.share.company,
          superAgent: financialGroupData.share.superAgent,
          driver: financialGroupData.share.driver,
          municipality: financialGroupData.share.municipality,
          tax: financialGroupData.share.tax,
        },
      },
      subscriptionAgent: {
        share: {
          admin: financialGroupData.share.admin,
          municipality: financialGroupData.share.municipality,
          company: financialGroupData.share.company,
          superAgent: financialGroupData.share.superAgent,
          driver: financialGroupData.share.driver,
          tax: financialGroupData.share.tax,
        },
        cycle: financialGroupData.cycle,
      },
    };
    // } else if (selectedType?.value === "company") {
    // total =
    //   Number(financialGroupData.share.admin) +
    //   Number(financialGroupData.share.superAgent) +
    //   Number(financialGroupData.share.tax);
    // data = {
    //   name: financialGroupData.name,
    //   subscriptionAgent: {
    //     share: {
    //       admin: financialGroupData.share.admin,
    //       company: financialGroupData.share.company,
    //       superAgent: financialGroupData.share.superAgent,
    //       driver: financialGroupData.share.driver,
    //       tax: financialGroupData.share.tax,
    //     },
    //     cycle: financialGroupData.cycle,
    //   },
    //   type: "company",
    // };
    // }

    if (!financialGroupData.name)
      errorsText = {
        ...errorsText,
        name: t("financial_group_name_is_required"),
      };
    if (!financialGroupData.cycle)
      errorsText = {
        ...errorsText,
        cycle: t("cycle_is_required"),
      };
    if (total !== 100)
      errorsText = {
        ...errorsText,
        total: t("total_pescent_should_be_100"),
      };
    if (!financialGroupData.agentSubscription)
      errorsText = {
        ...errorsText,
        agentSubscription: t("company_fee_is_required"),
      };

    setErrors(errorsText);

    if (
      // selectedType &&
      financialGroupData.name &&
      financialGroupData.cycle &&
      total === 100
    )
      createFunction(data);
  };

  return (
    <>
      <div className="create-financial">
        <CustomIcon
          icon="fas fa-circle-plus"
          hoverTitle={t("createFinancialGroup")}
          onClick={() => {
            setShowModal("CREATE");
          }}
        />
      </div>

      <CustomModal
        open={showModal === "CREATE"}
        onClose={() => setShowModal("NONE")}
        maxWidth={"55vw"}
        maxHeight={"80vh"}
        //minWidth={"55vw"}
      >
        <section className="create-role">
          <div id="create_financial_group_container">
            <CustomView.Container>
              <CustomView.Row className="form-row">
                {/* Group Name */}
                <CustomView.Column
                  large={4}
                  className="form-input-holder dropdown form-column"
                >
                  <CustomInput
                    placeHolder={t("financialGroupName")}
                    name="name"
                    value={financialGroupData?.name}
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev: any) => {
                        return {
                          ...prev,
                          name: event.target.value,
                        };
                      });
                      setErrors((prev) => ({ ...prev, name: "" }));
                    }}
                    label={t("financialGroupName")}
                  />
                  <div className="error">
                    {errors.name !== "" && errors.name}
                  </div>
                </CustomView.Column>
                {/* {selectedType?.value === "company" && ( */}
                <CustomView.Column
                  large={4}
                  className="form-input-holder dropdown form-column"
                >
                  <CustomInput
                    placeHolder={t("companyFee")}
                    name="agentSubscription"
                    value={
                      financialGroupData?.agentSubscription
                        ? financialGroupData?.agentSubscription
                        : 0
                    }
                    onValueChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                      setFinancialGroupData((prev: any) => {
                        return {
                          ...prev,
                          agentSubscription: Number(event.target.value),
                        };
                      });
                      setErrors((prev) => ({
                        ...prev,
                        agentSubscription: "",
                      }));
                    }}
                    label={t("companyFee")}
                  />
                  <div className="error">
                    {errors.agentSubscription !== "" &&
                      errors.agentSubscription}
                  </div>
                </CustomView.Column>
                {/* )} */}
              </CustomView.Row>
              {/* {selectedType && ( */}
              <>
                <CustomView.Row className="form-title">
                  <hr />
                  <div className="title-text">
                    <span>{t("subscriptionShare")}</span>
                    <span className="total-error">
                      {" "}
                      {errors.total !== "" && "(" + errors.total + ")"}
                    </span>
                  </div>
                </CustomView.Row>
                <CustomView.Row className="dropdown">
                  {/* Admin Share */}
                  <CustomView.Column large={4} className="form-input-holder">
                    <CustomInput
                      placeHolder={t("admin")}
                      name="admin_share"
                      value={financialGroupData?.share?.admin}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFinancialGroupData((prev: any) => {
                          return {
                            ...prev,
                            share: {
                              ...prev.share,
                              admin: event.target.value,
                            },
                          };
                        });
                      }}
                      label={t("admin")}
                    />
                  </CustomView.Column>
                  <CustomView.Column large={4} className="form-input-holder">
                    <CustomInput
                      placeHolder={t("municipality")}
                      name="admin_share"
                      value={financialGroupData?.share?.municipality}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFinancialGroupData((prev: any) => {
                          return {
                            ...prev,
                            share: {
                              ...prev.share,
                              municipality: event.target.value,
                            },
                          };
                        });
                      }}
                      label={t("municipality")}
                    />
                  </CustomView.Column>
                  {/* Group Name */}
                  <CustomView.Column large={4} className="form-input-holder">
                    <CustomInput
                      placeHolder={t("superAgent")}
                      name="superAgent_share"
                      value={financialGroupData?.share?.superAgent}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFinancialGroupData((prev: any) => {
                          return {
                            ...prev,
                            share: {
                              ...prev.share,
                              superAgent: event.target.value,
                            },
                          };
                        });
                      }}
                      label={t("superAgent")}
                    />
                  </CustomView.Column>
                  {/* Group Name */}
                  {/* {selectedType?.value === "student" && ( */}
                  <CustomView.Column large={4} className="form-input-holder">
                    <CustomInput
                      placeHolder={t("company")}
                      name="company_share"
                      value={financialGroupData?.share?.company}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFinancialGroupData((prev: any) => {
                          return {
                            ...prev,
                            share: {
                              ...prev.share,
                              company: event.target.value,
                            },
                          };
                        });
                      }}
                      label={t("company")}
                    />
                  </CustomView.Column>
                  {/* )} */}

                  {/* Group Name */}
                  {/* {selectedType?.value === "student" && ( */}
                  <CustomView.Column large={4} className="form-input-holder">
                    <CustomInput
                      placeHolder={t("driver")}
                      name="driver_share"
                      value={financialGroupData?.share?.driver}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFinancialGroupData((prev: any) => {
                          return {
                            ...prev,
                            share: {
                              ...prev.share,
                              driver: event.target.value,
                            },
                          };
                        });
                      }}
                      label={t("driver")}
                    />
                  </CustomView.Column>
                  {/* )} */}
                  {/* Group Name */}
                  <CustomView.Column large={4} className="form-input-holder">
                    <CustomInput
                      placeHolder={t("tax")}
                      name="travelShare_tax"
                      value={financialGroupData?.share?.tax}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFinancialGroupData((prev: any) => {
                          return {
                            ...prev,
                            share: {
                              ...prev.share,
                              tax: event.target.value,
                            },
                          };
                        });
                      }}
                      label={t("tax")}
                    />
                  </CustomView.Column>
                  <CustomView.Column
                    large={4}
                    className="form-input-holder dropdown"
                  >
                    <CustomInput
                      placeHolder={t("cycle")}
                      name="financialGroupTime"
                      value={financialGroupData?.cycle}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFinancialGroupData((prev: any) => {
                          return {
                            ...prev,
                            cycle: event.target.value,
                          };
                        });
                        setErrors((prev) => ({ ...prev, cycle: "" }));
                      }}
                      label={t("cycle")}
                    />
                    <div className="error">
                      {errors.cycle !== "" && errors.cycle}
                    </div>
                  </CustomView.Column>
                </CustomView.Row>
              </>
              {/* )} */}
            </CustomView.Container>
            <CustomView.Container>
              <CustomView.Row className="nav-buttons">
                <CustomView.Column large={3}>
                  <CustomButton2
                    // isLoading={isLoading}
                    // onClick={onCloseModal}
                    type="danger"
                    title={t("cancel")}
                  />
                </CustomView.Column>
                <CustomView.Column large={3}>
                  <CustomButton2
                    // isLoading={isLoading}
                    onClick={onCreate}
                    type="primary"
                    title={t("approve")}
                  />
                </CustomView.Column>
              </CustomView.Row>
            </CustomView.Container>
          </div>
        </section>
      </CustomModal>
    </>
  );
};

export default Create;
